import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { LabelHdrLoginSubjectLinkContainerModel } from '../../../../../../models/aggregates/erp/label';
import { Core2Config } from '../../shared/core2Config';

@Injectable({
  providedIn: 'root'
})
export class LabelHdrLoginSubjectLinkService extends BaseApiTemplateService<LabelHdrLoginSubjectLinkContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'label-login-subject-links/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'label-login-subject-links/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'label-login-subject-links/backoffice-ep';
    this.httpClient = http;
  }

}
